import BannerConnect from "../banner/BannerConnect";
import Footer from "../footer/Footer";
import Navigate from "../footer/Navigate";
import Header from "../header/Header";
import "./Connect.css";
import Connections from "./connections/Connections";
import Involved from "./involved/Involved";
import CommonBanner from "../banner/CommonBanner";
const Connect = () => {
  return (
    <>
      <Header />
      {/* <BannerConnect /> */}
      <CommonBanner
        id="page3"
        titleDesktop="Become a part of"
        subtitle="LCARP"
        titleMobile={"Become a part of"}
        titleClass={"desktop"}
      />
      <Involved />
      <Connections />
      <Navigate page="Home page" pagelink="/" />
      <Footer />
    </>
  );
};

export default Connect;
